import './shared/utils/browserPolyfills';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './app/App';
import { retireLegacyFlutterServiceWorker } from './shared/services/legacyFlutterServiceWorker';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

async function bootstrap(): Promise<void> {
  // The Flutter app's service worker is root-scoped and survives a Hosting
  // release swap. Retire it before rendering React; the helper reloads once
  // after unregistering so this document is no longer worker-controlled.
  const reloadingForLegacyWorker = await retireLegacyFlutterServiceWorker();
  if (reloadingForLegacyWorker) return;

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

void bootstrap();
